// extracted by mini-css-extract-plugin
module.exports = {"containerFullHeight":"Skeleton_containerFullHeight__2upXV","containerItemsCenter":"Skeleton_containerItemsCenter__1lPGT"};